module.exports = __webpack_public_path__ + "media/images/weather/315_day-c767cf977d1f1a7c24bf23b1862ceec3.png";